export default __webpack_public_path__ + "static/media/sleep_icon.19fb9243.svg";